import { useEffect, useRef } from 'react';
import { communityFacilities } from '@/mocks/homeData';

export default function CommunityGrid() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            entry.target.classList.remove('opacity-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="community" ref={sectionRef} className="relative w-full py-20 md:py-32 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="reveal opacity-0 inline-block px-4 py-1.5 mb-6 text-xs font-medium tracking-widest text-foreground-600 border border-foreground-300 rounded-full uppercase">
            Location Premium
          </span>
          <h2 className="reveal opacity-0 font-heading text-3xl md:text-5xl font-semibold text-foreground-900 mb-4 text-balance">
            입지 프리미엄
          </h2>
          <p className="reveal opacity-0 text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            신상도역 초역세권과 상도동 대규모 재개발의 시너지를 누려보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {communityFacilities.map((facility, i) => (
            <div
              key={facility.title}
              className="reveal opacity-0 group relative aspect-square md:aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer"
              style={{ animationDelay: `${i * 150}ms` }}
            >
              <img
                src={facility.image}
                alt={facility.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                width={800}
                height={800}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/5" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                <h3 className="text-2xl md:text-3xl font-bold text-background-50 mb-3 drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">{facility.title}</h3>
                <p className="text-base md:text-lg font-medium text-background-50 drop-shadow-[0_2px_6px_rgba(0,0,0,0.5)]">{facility.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}